import { takeLatest, call, put, all, select, fork } from 'redux-saga/effects'
import { createAction } from 'redux-starter-kit'
import { captureSentryException } from '@edulastic/common'
import { attchmentApi } from '@edulastic/api'

import { receiveClassStudentResponseAction } from '../src/actions/classBoard'

import {
  getTestActivitySelector,
  getAdditionalDataSelector,
  receiveTestActivitySaga,
} from '../ClassBoard/ducks'
import { SET_CLASS_STUDENT_RESPONSES_LOADING } from '../src/constants/actions'
import { SAVE_USER_WORK } from '../../assessment/constants/actions'

export const FETCH_PRINT_PREVIEW_ESSENTIALS =
  '[printPreview] fetch print preview essentials'

// -----|-----|-----|-----| ACTIONS BEGIN |-----|-----|-----|----- //

export const fetchPrintPreviewEssentialsAction = createAction(
  FETCH_PRINT_PREVIEW_ESSENTIALS
)

// -----|-----|-----|-----| ACTIONS ENDED |-----|-----|-----|----- //

// =====|=====|=====|=====| =============== |=====|=====|=====|===== //

// -----|-----|-----|-----| SAGAS BEGIN |-----|-----|-----|----- //

function* loadAttachmentsFromServer(filter) {
  try {
    const { referrerId, referrerId2, uqaId, qid } = filter
    const filterQuery = {
      referrerId,
      referrerId2,
    }
    if (!referrerId) {
      yield put({ type: SAVE_USER_WORK, payload: {} })
      const error = new Error('Fetch attachments failed')
      error.status = 500
      throw error
    }

    let { attachments = [] } = yield call(
      attchmentApi.loadAllAttachments,

      filterQuery
    )

    if (attachments.length > 1) {
      attachments = attachments.filter((a) => a.referrerId3 === qid)
    }

    const scratchpadData = {}
    for (const attachment of attachments) {
      const { data, referrerId3 } = attachment
      if (referrerId3) {
        scratchpadData[uqaId] = { [referrerId3]: data.scratchpad }
      } else {
        scratchpadData[uqaId] = data.scratchpad
      }
    }
    yield put({ type: SAVE_USER_WORK, payload: scratchpadData })
  } catch (error) {
    captureSentryException(error, filter)
    console.error('error from attachmentAPI', error)
  }
}

function* getAttachmentsForItems({ testActivityId, testItemsIdArray = [] }) {
  yield all(
    testItemsIdArray.map(({ testItemId, uqaId, _id, qid }) =>
      call(loadAttachmentsFromServer, {
        referrerId: testActivityId,
        referrerId2: testItemId,
        uqaId: uqaId || _id,
        qid,
      })
    )
  )
}

function* fetchPrintPreviewEssentials({ payload }) {
  const { assignmentId, classId: groupId, selectedStudents = [] } = payload
  try {
    const _payload = {
      assignmentId,
      classId: groupId,
      includeStudents: selectedStudents,
    }
    yield put({
      type: SET_CLASS_STUDENT_RESPONSES_LOADING,
      payload: true,
    })
    yield call(receiveTestActivitySaga, { payload: _payload })

    const testActivity = yield select(getTestActivitySelector)
    const additionalData = yield select(getAdditionalDataSelector)

    const { classId } = additionalData

    let selectedActivities = testActivity.filter(
      (item) => selectedStudents.includes(item.studentId) && item.testActivityId
    )
    selectedActivities = selectedActivities.map((item) => item.testActivityId)

    yield put(
      receiveClassStudentResponseAction({
        selectedActivities,
        groupId: classId,
      })
    )

    const uqas = yield select((state) =>
      (state.author_classboard_testActivity?.entities || []).flatMap(
        (item) => item?.questionActivities || []
      )
    )

    const uqasWithScratchpad =
      uqas.filter((uqa) => uqa?.scratchPad?.scratchpad) || []

    if (uqasWithScratchpad.length > 0) {
      yield all(
        uqasWithScratchpad.map((uqa) =>
          fork(getAttachmentsForItems, {
            testActivityId: uqa.testActivityId,
            testItemsIdArray: [
              {
                testItemId: uqa.testItemId,
                uqaId: uqa.qActId,
                qid: uqa._id,
              },
            ],
          })
        )
      )
    }
  } catch (error) {
    console.error(error)
    yield put({
      type: SET_CLASS_STUDENT_RESPONSES_LOADING,
      payload: false,
    })
  }
}

export function* printPreviewSaga() {
  yield all([
    takeLatest(FETCH_PRINT_PREVIEW_ESSENTIALS, fetchPrintPreviewEssentials),
  ])
}

// -----|-----|-----|-----| SAGAS ENDED |-----|-----|-----|----- //
